(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
